// An "unpublished Square draft" is an imported menu (origintype 10 =
// SquareImport) not yet assigned to any store — the same predicate the
// menu editor's Draft chip uses (menu-card.js).
const findUnpublishedSquareDraft = (menus) =>
  (menus || []).find(
    (m) => m.origintype === 10 && (!m.menustores || m.menustores.length === 0)
  ) || null;

export default findUnpublishedSquareDraft;
